(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('vp-payment', {
            parent: 'entity',
            url: '/vp-payment?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.vpPayment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vp-payment/vp-payments.html',
                    controller: 'VpPaymentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                field: null,
                client: null,
                amount: null,
                valueString1: null,
                valueLong1: null,
                fromDate: null,
                toDate: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        field: $stateParams.field,
                        client: $stateParams.client,
                        amount: $stateParams.amount,
                        valueString1: $stateParams.valueString1,
                        valueLong1: $stateParams.valueLong1,
                        fromDate: $stateParams.fromDate,
                        toDate: $stateParams.toDate
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vpPayment');
                    $translatePartialLoader.addPart('vpRequestType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('vp-payment-detail', {
            parent: 'vp-payment',
            url: '/vp-payment/{id}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                pageTitle: 'bozorakaAdminApp.vpPayment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vp-payment/vp-payment-detail.html',
                    controller: 'VpPaymentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vpPayment');
                    $translatePartialLoader.addPart('vpRequestType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VpPayment', function($stateParams, VpPayment) {
                    return VpPayment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'vp-payment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('vp-payment-detail.edit', {
            parent: 'vp-payment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vp-payment/vp-payment-dialog.html',
                    controller: 'VpPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VpPayment', function(VpPayment) {
                            return VpPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vp-payment.new', {
            parent: 'vp-payment',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vp-payment/vp-payment-dialog.html',
                    controller: 'VpPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                serviceId: null,
                                account: null,
                                amount: null,
                                amountFee: null,
                                localRate: null,
                                serviceRate: null,
                                date: null,
                                sign: null,
                                agentRequestId: null,
                                serverRequestId: null,
                                serverTransactionId: null,
                                payUrl: null,
                                client: null,
                                method: null,
                                status: null,
                                responseCode: null,
                                verifyRawXml: null,
                                paymentRawXml: null,
                                statusChecked: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('vp-payment', null, { reload: 'vp-payment' });
                }, function() {
                    $state.go('vp-payment');
                });
            }]
        })
        .state('vp-payment.edit', {
            parent: 'vp-payment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vp-payment/vp-payment-dialog.html',
                    controller: 'VpPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VpPayment', function(VpPayment) {
                            return VpPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vp-payment', null, { reload: 'vp-payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vp-payment.delete', {
            parent: 'vp-payment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vp-payment/vp-payment-delete-dialog.html',
                    controller: 'VpPaymentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VpPayment', function(VpPayment) {
                            return VpPayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vp-payment', null, { reload: 'vp-payment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vp-payment.profile', {
            url: '/profile/{phone}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_MANAGER', 'CUSTOMER_SUPPORT_PAYGRAM']
            },
            views: {
                'content@': {
                    controller: 'DepositProfileRedirectController',
                    controllerAs: 'vm'
                }
            }
        });
    }

})();
